module.exports = __webpack_public_path__ + "static/media/page3_sama1.83979e8f.wav";